<template>
  <v-slide-x-transition>
    <v-breadcrumbs v-if="items.length" :items="items" divider=">">
      <template #item="{ item }">
        <component :is="item.to ? 'router-link' : 'span'" :to="item.to">
          <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
          {{ item.text }}
        </component>
      </template>
    </v-breadcrumbs>
  </v-slide-x-transition>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapState } = createNamespacedHelpers("classifier");

export default {
  computed: {
    ...mapGetters(["classificationsSellerName"]),
    ...mapState(["classificationsSellerId", "currentClassification"]),
    items() {
      const route = this.$route.name;
      const baseItems = [
        {
          icon: "home",
          to: { name: "home" }
        },
        {
          text: "Sellers",
          to: { name: "classifier/sellers" }
        },
        {
          text: `${this.classificationsSellerName} (${this.classificationsSellerId})`
        },
        {
          text: "Clasificaciones",
          to: { name: "classifier/classifications" }
        },
        {
          text: this.currentClassification
            ? `${this.currentClassification.name} (${this.currentClassification.id})`
            : this.$route.params.classificationId,
          to: { name: "classifier/predictions/items" }
        },
        {
          text: "Validados"
        }
      ];

      switch (route) {
        case "classifier/sellers":
          delete baseItems[1].to;
          return baseItems.slice(0, 2);
        case "classifier/classifications":
          delete baseItems[3].to;
          return baseItems.slice(0, 4);
        case "classifier/predictions":
        case "classifier/predictions/categories":
        case "classifier/predictions/items":
          delete baseItems[4].to;
          return baseItems.slice(0, 5);
        case "classifier/predictions/validated":
          return baseItems;
        default:
          return [];
      }
    }
  }
};
</script>